import axios from 'axios'

const AxiosInstance = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}/v1/`,
  timeout: 10000,
})

export default AxiosInstance
